import { useState, useEffect } from "react";

// ── Pure React frontend — no Node.js imports ──────────────────
// All backend logic stays in server.js + copyTradingRoutes.js
// This file only calls the API via fetch()

export default function CopyTrading() {
  const [groups,  setGroups]  = useState([]);
  const [status,  setStatus]  = useState("");
  const [loading, setLoading] = useState(false);

  // Load groups from backend on mount
  useEffect(() => {
    fetch("/api/copy/groups")
      .then(r => r.json())
      .then(d => setGroups(d.groups || []))
      .catch(() => {});
  }, []);

  // Sync ct_groups + ct_accounts from localStorage to backend
  const syncGroups = async () => {
    setLoading(true);
    setStatus("");
    try {
      const ctGroups   = JSON.parse(localStorage.getItem("ct_groups")   || "[]");
      const ctAccounts = JSON.parse(localStorage.getItem("ct_accounts") || "[]");

      const res = await fetch("/api/copy/groups/sync", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ctGroups, ctAccounts }),
      });
      const data = await res.json();

      setStatus(`✅ Synced ${data.groupCount} group(s) to copy engine`);

      // Reload groups list
      const r2 = await fetch("/api/copy/groups");
      const d2 = await r2.json();
      setGroups(d2.groups || []);
    } catch (e) {
      setStatus("❌ Sync failed: " + e.message);
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: 24, color: "#e2e8f0", minHeight: "100vh", background: "#0f172a" }}>
      <h2 style={{ fontSize: 24, fontWeight: "bold", marginBottom: 20 }}>
        🔁 Copy Trading Groups
      </h2>

      <div style={{ marginBottom: 20, display: "flex", gap: 12, alignItems: "center" }}>
        <button
          onClick={syncGroups}
          disabled={loading}
          style={{
            background: loading ? "#334155" : "#3b82f6",
            border: "none", color: "#fff",
            padding: "10px 24px", borderRadius: 8,
            cursor: loading ? "not-allowed" : "pointer",
            fontSize: 14, fontWeight: "bold",
          }}
        >
          {loading ? "⟳ Syncing..." : "⟲ Sync Groups to Engine"}
        </button>

        {status && (
          <span style={{ fontSize: 13, color: status.startsWith("✅") ? "#22c55e" : "#ef4444" }}>
            {status}
          </span>
        )}
      </div>

      <p style={{ color: "#64748b", fontSize: 13, marginBottom: 20 }}>
        Groups are created in the <strong style={{ color: "#94a3b8" }}>Groups</strong> page.
        Click Sync to push them to the copy engine backend.
      </p>

      {/* Groups list */}
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {groups.length === 0 && (
          <div style={{ color: "#475569", padding: "40px 0", textAlign: "center" }}>
            No groups synced yet. Go to Groups page to create groups, then click Sync.
          </div>
        )}

        {groups.map(g => (
          <div key={g.id} style={{
            background: "#1e293b", border: "1px solid #334155",
            borderRadius: 10, padding: "16px 20px",
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
              <span style={{ fontWeight: "bold", fontSize: 16 }}>{g.name}</span>
              <span style={{ fontSize: 12, color: "#64748b" }}>ID: {g.id}</span>
            </div>
            <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 8 }}>
              Master: <span style={{ color: "#38bdf8" }}>{g.masterClientId}</span>
            </div>
            <div style={{ fontSize: 12, color: "#64748b" }}>
              {(g.followers || []).length} follower(s):&nbsp;
              {(g.followers || []).map(f => (
                <span key={f.clientId} style={{
                  background: "#0f2040", color: "#38bdf8",
                  padding: "2px 8px", borderRadius: 4, marginRight: 6, fontSize: 11,
                }}>
                  {f.clientId} ({f.mode} ×{f.value})
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}